/**
 * 资源来源
 */
export enum AssetSource {
  /** 用户自己上传的 */
  User = 1,
  /** 来自公共库 */
  Public = 2,
  /** 来自资产库 */
  Asset = 3,
  /** ai生成的资源 */
  AI = 5,
  /** 从模版复制过来的 */
  Template = 6,
}

// 2内部/1外部 资源
export enum AssetVisible {
  Public = 1,
  Internal = 2,
}

export enum AssetType {
  // 音频
  Audio = 'audio',
  // 图片
  Image = 'image',
  // 视频
  Video = 'video',
  // 文本
  Text = 'text',
  // 滤镜
  Filter = 'filter',
  // 转场
  Transition = 'transition',
  // 动图
  Animation = 'animation',
}

/**
 * 资产组类型
 */
export enum AssetGroupType {
  // 音频
  Audio = 'audio',
  // 图片、动画、序列帧
  Image = 'image',
  // 视频
  Video = 'video',
  // 文本
  Text = 'text',
}

export enum FileExt {
  GIF = 'gif',
  MP4 = 'mp4',
  MP3 = 'mp3',
  JPG = 'jpg',
  PNG = 'png',
  FLV = 'flv',
  AVI = 'avi',
  ZIP = 'zip',
}

// 1：视频、图片 2：贴纸 3：文字 ，仅动画有该字段
export enum AnimationResource {
  Video = 1,
  Sticker = 2,
  Text = 3,
}

// 公共资产库资源的类型
export enum CommonAssetType {
  Video = 1, // 视频资源
  Image = 2, // 图片
  Animation = 3, // 动图
  Audio = 4, // 音频
  Particle = 5, // 粒子
  Font = 6, // 字体
  DragonBone = 7, // 龙骨
  FlowerWord = 8, // 花字
  Transition = 9, // 转场
  Filter = 10, // 滤镜
  Cartoon = 11, // 动画
}

export const CommonToAssetTypeMap: Record<
  CommonAssetType,
  AssetType | undefined
> = {
  [CommonAssetType.Video]: AssetType.Video,
  [CommonAssetType.Image]: AssetType.Image,
  [CommonAssetType.Animation]: AssetType.Animation,
  [CommonAssetType.Audio]: AssetType.Audio,
  [CommonAssetType.Particle]: undefined,
  [CommonAssetType.Font]: undefined,
  [CommonAssetType.DragonBone]: undefined,
  [CommonAssetType.FlowerWord]: undefined,
  [CommonAssetType.Transition]: AssetType.Transition,
  [CommonAssetType.Filter]: AssetType.Filter,
  [CommonAssetType.Cartoon]: undefined,
}

// AssetStatus 资源状态
export enum AssetStatus {
  Pending = 'pending', // 待上传
  Transcoding = 'transcoding', // 转码中
  Active = 'active', // 可用
  Error = 'error', // 出错
}

// shotStatus 视频资源-分镜状态
export enum shotStatus {
  Pending = 'pending', // 解析中
  Success = 'success', // 成功
  Failed = 'failed', // 失败
}

// AI异步任务状态
export enum AiTaskStatus {
  Pending = 'pending', // 解析中
  Running = 'running', // 进行中
  Success = 'success', // 任务成功
  Failed = 'failed', // 任务失败
}

// 是否是带透明通道的视频
export enum AssetAlpha {
  No,
  Yes,
}

// 异步任务类型
export enum AsyncTaskType {
  AsyncTaskTypeDVS = 'ai.dvs',
  AsyncTaskTypeSplit = 'ai.split',
}
